import { forwardRef } from "react";

/**
 * Servora loading spinner — the brand ring, rotating.
 * Drop-in replacement for lucide's Loader2: same props (className for size/colour/animate-spin),
 * inherits currentColor so it keeps working in buttons, cards and full-page loaders.
 */
export const Loader2 = forwardRef(function Loader2({ className = "", strokeWidth, size, ...rest }, ref) {
  const style = size ? { width: size, height: size } : undefined;
  return (
    <svg ref={ref} viewBox="0 0 24 24" fill="none" className={className} style={style} role="status" aria-label="Laddar" {...rest}>
      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeOpacity="0.22" strokeWidth="4.2" />
      <path d="M12 4 A8 8 0 1 1 4.34 14.4" stroke="currentColor" strokeWidth="4.2" strokeLinecap="round" />
    </svg>
  );
});

export default Loader2;
